import React from "react";
import {Form, Tabs, Container, Tab,Row,Col,Nav} from "react-bootstrap";
import './menu.css'

function SideMenu(props){
    let children = React.Children.toArray(props.children);
    const renderSidemenu = (child,index) =>
        
        (
        
        <Nav variant={"pills"} key={index}>
            <Nav.Item>
                <Nav.Link eventKey={child.props.indexKey}>{child.props.title}</Nav.Link>
            </Nav.Item>
        </Nav>
    )
    const renderContent = (child,index) =>(
        
        <Tab.Pane eventKey={child.props.indexKey} key={index}>
        <br/>
          {child}
        </Tab.Pane>
       
    )
   
    
    return(
        <div  >
                    <Tab.Container defaultActiveKey={props.defaultKey}>
                        <Row>
                            <Col sm={2}>
                                <div className={'col-menu'}>
                                    <h5>Categories</h5>
                                    {children.map(renderSidemenu)}
                               
                                </div>

                            </Col>

                            <Col sm={9} className="data-container">
                                <Tab.Content  >
                                   {children.map(renderContent)}
                                    
                                </Tab.Content>
                            </Col>

                            </Row>

                    </Tab.Container>
                    </div>
    )
}
export default SideMenu;